<template>
    <div>
        <el-dialog :visible.sync="showBox" @close="closeModal">
        <p slot="title" style="text-align: center; color: #1A86FE">
            <span>{{$store.state.agentInfo.name}}服务协议</span>
        </p>
        <ul class="server-font">
            <li>
                （以下称“本协议”）是{{$store.state.agentInfo.name}}（以下称“{{$store.state.agentInfo.name}}”）与您就充值卡转让服务（或称“本服务”）所订立的有效合约。您通过{{$store.state.agentInfo.name}}网站（以下统称“{{$store.state.agentInfo.name}}平台”或“本平台”）勾选“同意”本协议，即表示您与{{$store.state.agentInfo.name}}已达成协议、同意接受本协议的全部约定内容，并承诺遵照执行。<br>
                <span class="underline">特别提示：在接受本协议之前，请您仔细阅读本协议的全部内容（特别是以粗体下划线标注的内容）。如果您不同意本协议的任意内容，或者无法准确理解本网站对条款的解释，请不要勾选“同意”并进行后续操作。</span>
            </li>
            <li>
            <p>第一条  相关定义</p>
                1、充值卡转让：本协议所称充值卡转让，是指本平台为您提供的充值卡转让服务。您可将您合法持有的充值卡，在本平台转让给{{$store.state.agentInfo.name}}合作商户，转让所得的金额将直接转入您的{{$store.state.agentInfo.name}}账户。具体支持的充值卡卡种以您使用本服务时的页面提示为准。<br>
                2、<span class="underline">转让收益：指您通过{{$store.state.agentInfo.name}}平台转让充值卡所获得的收入，按照“面值*折扣”进行计算，</span>其中：<br>
                （1）面值：指您待转让充值卡对应的储值金额；<br>
                （2）折扣：指针对您待转让的充值卡，您自行设置的转让折扣。<br>
                3、合作商户：指系指在{{$store.state.agentInfo.name}}平台上开设认证账户，同意遵守充值缴费的相关服务协议，成功通过{{$store.state.agentInfo.name}}审核，并开通充值缴费账户的企业或个人。
            </li>
            <li>
            <p>第二条 充值卡提交</p>
            1、您通过本平台转让充值卡，需按照本平台要求自行提交待转让充值卡。<br>
            2、充值卡提交要求：<br>
            （1）准确选择与实际情况相符的卡种、面值；<br>
            （2）准确填写卡号、卡密，禁止捏造或纂改卡号、卡密；<br>
            （3）提交已激活且有效的充值卡；如卡券已经被使用或被绑定，则无法成功转让；如未激活，请您自行联系卡券运营商进行处理；<br>
            （4）自行设置折扣，具体的折扣设置要求详见“第三条折扣设置”。<br>
            <span class="underline">
                3、充值卡提交不符合要求的处理：<br>
                （1）面值与余额不一致的，造成的一切损失由您自行承担，其中：<br>
                &nbsp;&nbsp;如属于“小传大”（即：实际面值小于选择的面值），则不予结算转让收益；<br>
                &nbsp;&nbsp;如属于“大传小”（即：实际面值大于选择的面值），则按照选择的面值及本协议规定结算转让收益； <br>
                （2）如捏造或纂改卡号卡密，不予结算转让收益；如因此给{{$store.state.agentInfo.name}}造成损失的，您需要予以赔偿。<br>
            </span>
            </li>
            <li>
            <p>第三条 折扣设置</p>
            1、折扣由您自行设置，但不得高于{{$store.state.agentInfo.name}}设置的初始折扣。<br>
            2、本平台将按照您设置的折扣及本协议规定向您结算转让收益。<br>
            3、折扣设置完成后，一经提交不得更改，请您务必核对折扣设置，以及对应的充值卡转让金额（即：最终您可获取的收益金额）。<br>
            <span class="underline"> 4、因折扣设置错误造成的损失由您自行承担；折扣设置并提交后，您又以折扣填写错误为由要求{{$store.state.agentInfo.name}}或本平台修改，或者重新确认转让收益并结算的，{{$store.state.agentInfo.name}}及本平台有权利拒绝。</span><br>
            </li>
            <li>
            <p>第四条回款和费用</p>
            1、充值卡完成转让且{{$store.state.agentInfo.name}}收到合作商户支付的款项后，{{$store.state.agentInfo.name}}向您付款；除本协议另有规定外，付款金额为“面值*折扣”。各卡种回款时间具体以使用本服务的页面提示为准。<br>
            2、如{{$store.state.agentInfo.name}}合作商户需要开具发票的，您应负责就您实际收取的转让收益向{{$store.state.agentInfo.name}}合作商户开具。<br>
            3、为了您的资金安全，您需要在工作日8：00-20：00申请提现并与客服咨询提现问题，其余时间{{$store.state.agentInfo.name}}及本平台将不予办理。<br>
            4、{{$store.state.agentInfo.name}}提供本服务需收取一定服务费，服务费金额由{{$store.state.agentInfo.name}}合作商户受让充值卡金额决定，具体按照下列方式计算：{{$store.state.agentInfo.name}}合作商户受让金额-面值*折扣。<br>
            5、依据前款规定，{{$store.state.agentInfo.name}}合作商户受让金额高出“面值*折扣”的所有部分均归{{$store.state.agentInfo.name}}所有，您无权提出任何主张。<br>
            </li>
            <li>
            <p>第五条 注册信息和隐私保护</p>
            1、本平台账号（即本平台中您账号）的所有权归本平台，您完成注册申请手续后，获得本平台账号的使用权。您应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽、准确的要求。所有原始键入的资料将引用为注册资料。如果因注册信息不真实而引起的问题，及对该问题发生所带来的后果，本平台不负任何责任。<br>
            2、您不应将其账号、密码转让、出售或出借等形式予他人使用，若您授权他人使用账户，应对被授权人在该账户下发生所有行为负全部责任。<br>
            3、在如下情况下，本平台可能会披露您的信息：<br>
            （1）事先获得您的授权；<br>
            （2）根据法律、法规、法律程序的要求或政府主管部门的强制性要求；<br>
            （3）符合相关服务条款或使用协议的规定。<br>
            4、为更好地向您提供服务，您同意本平台在事先征得您同意的情况下通过短信等形式向您发送相关商业性服务信息。<br>
            5、关于认证服务的理解与认同<br>
            （1）认证服务是由本平台所有者{{$store.state.agentInfo.name}}提供的一项身份识别服务。除非本协议另有约定，一旦您的平台账户完成了认证，相应的身份信息和认证结果将不因任何原因被修改或取消。<br>
            （2）{{$store.state.agentInfo.name}}向您提供的认证服务包括以下具体程序： 1、账户注册过程中的手机号识别 2、申请提现过程中的身份信息、银行卡号（或支付宝账号）识别，{{$store.state.agentInfo.name}}有权记录并保存您完成以上程序提供给{{$store.state.agentInfo.name}}的信息和{{$store.state.agentInfo.name}}获取的结果信息，亦有权根据本协议的约定向您提供您是否通过认证的结论以及您的身份信息。<br>
            6、银行账户识别<br>
            （1）个人{{$store.state.agentInfo.name}}用户应提供本人在大陆银行开设的人民币账号、开户名、开户银行。<br>
            （2）企业类{{$store.state.agentInfo.name}}用户应提供其在大陆银行开设的人民币账号、开户名、开户银行。<br>
            （3）您填写的银行账户的开户名必须与身份信息中的真实姓名或营业执照、组织机构代码证中的名称完全一致，所有经{{$store.state.agentInfo.name}}您填写的资料将成为认证资料。<br>
            （4）若您尚不具备完全民事行为能力，而以提供不实认证资料的方式，使{{$store.state.agentInfo.name}}误认为该您是完全民事行为能力人而受理身份信息识别申请的，则因此产生的一切后果将由您及您的监护人承担，{{$store.state.agentInfo.name}}不承担任何责任。<br>
            7、有关与您的个人信息的收集、使用、保存、共享及转让等相关的事宜，本条没有具体规定的，按照《{{$store.state.agentInfo.name}}隐私政策》执行；本条规定与《{{$store.state.agentInfo.name}}隐私政策》不一致的，亦以《{{$store.state.agentInfo.name}}隐私政策》为准。<br>
            </li>
            <li>
            <p>第六条 权利义务</p>
            1、<span class="underline">您必须保证充值卡密来源的合法性，对该卡密来源的合法性承担责任，{{$store.state.agentInfo.name}}拒绝一切通过传销、诈骗、盗刷等非法手段获取的充值卡密，一经发现异常情况，{{$store.state.agentInfo.name}}有义务告知公安机关进行调查处理，并向公安机关提供您的交易记录和个人信息，{{$store.state.agentInfo.name}}对该卡密的合法性不承担任何责任，因此给{{$store.state.agentInfo.name}}造成任何损失的，由您承担。</span><br>
            2、使用本服务的，您需要符合{{$store.state.agentInfo.name}}实名制度。<br>
            3、您需按照页面提示选择正确的充值卡面值。如实际面值与选择的面值不一致的，可能导致延期到账、失败甚至不予结算，由此产生的损失由您自行承担，{{$store.state.agentInfo.name}}对此不承担责任。<br>
            4、您需遵守页面提示的每日或每月的最高转让限额，否则对超过限额的转让，{{$store.state.agentInfo.name}}有权不提供服务。<br>
            5、如因充值卡卡密不正确、转让前已经使用、未激活等原因,导致充值卡不能转让的,您需自行联系发卡商（即电信业务运营商、中石油、中石化等）解决，{{$store.state.agentInfo.name}}不介入处理。<br>
            6、{{$store.state.agentInfo.name}}应按照本协议的约定及页面提示，向您提供充值卡转让服务，并保证您成功转让的资金依据本协议规定及时转入您的账户。<br>
            </li>
            <li>
            <p>第七条 其他</p>
            1、本协议适用中华人民共和国大陆地区法律。因{{$store.state.agentInfo.name}}与您就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成，{{$store.state.agentInfo.name}}和您同意提交{{$store.state.agentInfo.name}}住所地法院管辖审理双方的纠纷或争议。<br>
            2、本协议内容包括协议正文及所有{{$store.state.agentInfo.name}}已经发布的或将来可能发布的{{$store.state.agentInfo.name}}服务的使用规则。所有规则为本协议不可分割的一部分，与协议正文具有相同法律效力。<br>
            3、本协议未尽事宜，以本平台上公布的相关规则为准。<br>
            4、本平台未行使或执行本服务协议任何权利或规定，不构成对前述权利或规定之放弃。<br>
            5、如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。<br>
            6、由于您将{{$store.state.agentInfo.name}}账户密码告知他人或未保管好自己的密码或与他人共享{{$store.state.agentInfo.name}}账户或任何其他非本平台的过错，导致您的个人资料泄露，概与本平台无关。<br>
            7、任何由于黑客攻击、计算机病毒侵入或发作、电信部门技术调整导致之影响、因政府管制而造成的暂时性关闭、由于第三方原因(包括不可抗力，如火灾、水灾、雷击、地震、洪水、台风、龙卷风、火山爆发、瘟疫和传染病流行、罢工、战争或暴力行为或类似事件等)及其他非因{{$store.state.agentInfo.name}}过错而造成的认证信息泄露、丢失、被盗用或被篡改等，概与本平台无关。<br>
            8、由于与{{$store.state.agentInfo.name}}链接的其它网站（如网上银行等）所造成的银行账户信息泄露及由此而导致的任何法律争议和后果，概与本平台无关。<br>
            9、任何您（包括未成年人用户）向{{$store.state.agentInfo.name}}提供错误、不完整、不实信息等造成不能通过认证或遭受任何其他损失，概与本平台无关。<br>
            10、本平台所有权及本协议最终解释权归{{$store.state.agentInfo.name}}所有。<br>
            </li>
        </ul>
        <p slot="footer"></p>
        </el-dialog>
	</div>
</template>

<script>
export default {
    data(){
        return{
        }
    },
    props:['showserver'],
    computed:{
        showBox:{
            get: function() {
                return this.showserver
            },
            set: function() {
            }
        }
    },
    methods:{
        closeModal(){
            this.$emit('update-show',false);
        }
    }
}
</script>

<style scoped lang="scss">
.server-font{
  height:600px;
  overflow-y: scroll;
  -ms-overflow-y: scroll;
  li{
    color: rgb(88,88,88);
    margin-bottom: 25px;
    span,p{
      font-size: 14px;
      font-weight: bold;
      color: rgb(37,37,37);
    }
  }
  li:first-child{
    color: rgb(37,37,37);
  }
  .underline {
        text-decoration:underline
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/agreement.vue